<template>
	<div class="search-bar inline-between">
		<el-input ref="searchInput" v-model="keyWord" :style="inputStyle" @change="searchEnterFun" 
			@blur="visible = false"></el-input>
		<img class="search-icon" src="~@/assets/svg/icon-search.svg" 
			:class="{'expand': visible}" @click="searchEnterFun" />
	</div>
</template>
<script>
	export default {
		name: 'SearchBar',
		data() {
			return {
				keyWord: '',
				visible: false
			}
		},
		computed: {
			inputStyle() {
				if(this.visible) {
					return {
						width: '100%'
					}
				}else {
					return {
						width: '0px',
						border: 'none',
					}
				}
			}
		},
		methods: {
			searchEnterFun() {
				if(!this.visible) {
					this.visible = true;
					this.$nextTick(() => {
						this.$refs.searchInput.focus();
					});
					return;
				}
				if(this.keyWord) {
					if(this.$route.path == '/search') {
						this.$bus.$emit('search', {keyWord: this.keyWord})
					}else {
						this.$router.push({path: 'search', query: {keyWord: this.keyWord}});
					}
				}
			}
		}
	}
</script>
<style scoped lang="less">
	.search-bar {
		flex: 1;
		position: relative;
		height: 100%;
		padding-left: calc(50px * var(--scale-rate));
		justify-content: flex-end;
	}
	::v-deep {
		.el-input {
			border-radius: calc(30px * var(--scale-rate));
			overflow: hidden;
			background: transparent;
			border: 1px solid rgba(49, 75, 137, 0.2); 
			transition: 1s;
			input {
				background: transparent;
				border: none;
				line-height: calc(60px * var(--scale-rate));
				height: calc(60px * var(--scale-rate));
				padding: 0 calc(80px * var(--scale-rate)) 0 calc(30px * var(--scale-rate));
				color: rgba(0, 0, 0, 1);
				font-size: calc(30px * var(--scale-rate));
			}
		}
		.search-icon {
			position: absolute;
			right: calc(20px * var(--scale-rate));
			width: calc(50px * var(--scale-rate));
			height: calc(52px * var(--scale-rate));
		}
		
		.expand {
			position: absolute;
			top: calc(13px * var(--scale-rate));
			right: calc(20px * var(--scale-rate));
			width: calc(40px * var(--scale-rate));
			height: calc(42px * var(--scale-rate));
		}
	}
	
</style>